<div
  (appClickOutside)="closeDropdown()"
  *ngIf="selectForm"
  class="select-duration"
  [formGroup]="selectForm"
  appPressEscapeKey
  (pressEscapeKey)="closeDropdown()"
>
  <div class="select-duration__element" appDropdownPanel>
    <mat-icon
      *ngIf="!modalOpen && (isMobile$ | async) === false"
      class="select-duration__icon"
      matPrefix
      [svgIcon]="field.icon"
      role="presentation"
    ></mat-icon>

    <button
      type="button"
      class="dropdown dropdown--filter dropdown-left-0 select-duration__container btn-clean"
      [class.select-duration__container--default-color]="(showPlaceholder$ | async) && (isMobile$ | async)"
      [class.select-duration__container--selected-color]="(showPlaceholder$ | async) && (isMobile$ | async) === false"
      [attr.aria-expanded]="showDropdown$ | async"
      aria-controls="select-dropdown"
      (click)="openCloseDropdown()"
    >
      {{ (showPlaceholder$ | async) ? field.placeholder : (valueToDisplay$ | async) }}
      <mat-icon
        *ngIf="!value"
        class="select-duration__icon__arrow"
        [class.select-duration__icon__arrow--open]="showDropdown$ | async"
        svgIcon="arrow_next"
        role="presentation"
      ></mat-icon>
      <button
        type="button"
        *ngIf="value"
        (click)="clearValue()"
        class="delete-btn select-duration__delete-btn btn-clean"
        [attr.aria-label]="'Suppression du filtre ' + field.placeholder | lowercase | upperfirst"
      >
        <mat-icon svgIcon="cross" class="select-duration__icon__delete" role="presentation"></mat-icon>
      </button>
    </button>

    <div
      *ngIf="(showDropdown$ | async) && selectForm"
      id="select-dropdown"
      class="select-dropdown"
      [formGroup]="selectForm"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <button
        type="button"
        *ngFor="let val of field.value; trackBy: trackByDurationSelectSearchValue"
        class="btn-clean select-dropdown__option"
        [attr.aria-label]="val.label"
        (click)="selectValue(val)"
        [attr.aria-expanded]="showInputFields$ | async"
        aria-controls="select-dropdown__time"
        cdkFocusRegionStart
      >
        {{ val.label }}
      </button>

      <div
        id="select-dropdown__time"
        class="select-dropdown__time"
        *ngIf="(showInputFields$ | async) && (isMobile$ | async) === false"
      >
        <div class="hours-input__separator"></div>
        <p class="hours-input__text">Durée hebdomadaire&nbsp;:</p>
        <div *ngIf="selectForm" class="hours-input__fields">
          <mat-form-field>
            <input
              type="number"
              matInput
              formControlName="from"
              (focus)="searchFromIsFocused = true"
              (blur)="searchFromIsFocused = false"
              placeholder="De..."
              attr.aria-label="De ..."
            />
            <p matSuffix>h</p>
          </mat-form-field>

          <mat-form-field class="hours-input__fields__second">
            <input
              type="number"
              matInput
              formControlName="to"
              (focus)="searchToIsFocused = true"
              (blur)="searchToIsFocused = false"
              placeholder="À..."
              attr.aria-label="À ..."
            />
            <p matSuffix>h</p>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="mobile-fields"
  *ngIf="(showInputFields$ | async) === true && (isMobile$ | async) === true && selectForm"
  [formGroup]="selectForm"
>
  <mat-form-field>
    <input
      type="number"
      class="mobile-fields__field"
      matInput
      formControlName="from"
      (focus)="searchFromIsFocused = true"
      (blur)="searchFromIsFocused = false"
      placeholder="De..."
      attr.aria-label="De ..."
    />
    <p matSuffix>h</p>
  </mat-form-field>

  <mat-form-field class="hours-input__fields__second">
    <input
      type="number"
      class="mobile-fields__field"
      matInput
      formControlName="to"
      (focus)="searchToIsFocused = true"
      (blur)="searchToIsFocused = false"
      placeholder="À..."
      attr.aria-label="À ..."
    />
    <p matSuffix>h</p>
  </mat-form-field>
</div>
